import { locale, t } from "./i18n";

// browserOf names the browser and system a session's user agent says, as
// "Chrome on macOS", for one's list of where one is signed in.
export function browserOf(ua: string): string {
  const browser = /Edg\//.test(ua)
    ? "Edge"
    : /OPR\//.test(ua)
      ? "Opera"
      : /Firefox\//.test(ua)
        ? "Firefox"
        : /Chrome\/|CriOS\//.test(ua)
          ? "Chrome"
          : /Safari\//.test(ua) && /Version\//.test(ua)
            ? "Safari"
            : "";
  const system = /iPhone/.test(ua)
    ? "iPhone"
    : /iPad/.test(ua)
      ? "iPad"
      : /Android/.test(ua)
        ? "Android"
        : /CrOS/.test(ua)
          ? "ChromeOS"
          : /Mac OS X|Macintosh/.test(ua)
            ? "macOS"
            : /Windows/.test(ua)
              ? "Windows"
              : /Linux/.test(ua)
                ? "Linux"
                : "";
  if (browser && system) return t("{browser} on {system}", { browser, system });
  return browser || system || t("An unknown browser");
}

// ago is how long ago something was, as "5 minutes ago"; under a minute,
// "just now".
export function ago(when: string | Date, now = Date.now()): string {
  const s = Math.round((now - new Date(when).getTime()) / 1000);
  if (s < 60) return t("just now");
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  for (const [unit, size] of [
    ["day", 86400],
    ["hour", 3600],
    ["minute", 60],
  ] as const) {
    if (s >= size) return rtf.format(-Math.floor(s / size), unit);
  }
  return t("just now");
}
